import { Grid, Box } from '@mui/material'
import { ShoesState } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { ItemCell } from 'src/Components/Domain/ItemCell'
import { muiGrey } from 'src/style/muiTheme'
import { ShoesEmbroideries } from 'src/features/simulationConfirm/Components/ShoesEmbroideries'
import { getShoesBaseCells, getShoesColorCells } from 'src/logic/simulationSpecification/shoes'

export const cellColor = (cellValue: string) => (cellValue === 'unselected' ? 'red' : muiGrey)

type Props = {
  state: ShoesState
}

export const ShoesSimulationContent: React.FC<Props> = ({ state }) => {
  const { t } = useLocale()
  const baseCells = getShoesBaseCells(state)
  const colorCells = getShoesColorCells(state)
  const baseCellCount = baseCells.length

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
            {t.BASE_ITEMS}
          </Box>
          {baseCells.map((cell, i) => (
            <ItemCell key={cell.head} itemIndex={i + 1} cell={cell} color={cellColor(cell.value)} isNewLine />
          ))}
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
            {t.COLOR_ITEMS}
          </Box>
          {colorCells.map((cell, i) => (
            <ItemCell key={cell.head} itemIndex={i + baseCellCount + 1} cell={cell} color={cellColor(cell.value)} />
          ))}
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <ShoesEmbroideries embroideries={state.embroideries} previousIndex={1} />
        </Box>
      </Grid>
    </Grid>
  )
}
